module.exports = __webpack_public_path__ + "media/images/icon__twitter@2x-b35ca160b635406e91bf1e873487320f.png";